<template>
    <div>
        <el-tabs v-model="tabValue">
            <el-tab-pane label="分区访问" name="zoneWhite">
                <ZoneVisitWhiteListPage v-if="tabValue == 'zoneWhite'"/>
            </el-tab-pane>
            <el-tab-pane label="玩家数据校验" name="playerDataWhite">
                <PlayerDataAuditWhiteListPage v-if="tabValue == 'playerDataWhite'"/>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
  
<script>
import ZoneVisitWhiteListPage from "./tab-pages/ZoneVisitWhiteListPage";
import PlayerDataAuditWhiteListPage from "./tab-pages/PlayerDataAuditWhiteListPage";

export default {
    data() {
        return {
            tabValue: "zoneWhite",
        };
    },

    async created() {
    },

    components: {
        ZoneVisitWhiteListPage,
        PlayerDataAuditWhiteListPage,
    },

    methods: {
    },
};
</script>